import React, { useState } from "react";
import { useDispatch } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import ClearTwoToneIcon from '@material-ui/icons/ClearTwoTone';
import SendTwoToneIcon from '@material-ui/icons/SendTwoTone';
import CommentIcon from '@material-ui/icons/Comment';
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import postMessage from "../../redux/reducers/message-reducer";
import {useFormik} from "formik";
import {makeStyles} from "@material-ui/core";
import {Tooltip} from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
    MessageButton: {
        color: '#ffffff',
    },
    button: {
        padding: theme.spacing(2),
    },
    root: {
        width: '100%',
        '& > * + *': {
          marginTop: theme.spacing(2),
        },
    },
}))

export const InlineChat = () => {

    const classes = useStyles()

    const dispatch = useDispatch()
    const [state, setState] = useState(false);
    const [open, setOpen] = useState(false);

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
      }

    const onSubmit = async (message) => {
        await dispatch(postMessage(message))
        handleCloseDialog()
        handleSuccess()
    }

    const {getFieldProps, resetForm, submitForm} = useFormik({
        initialValues: {
            message: ''
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        resetForm()
        setState(!state)
    }

    const handleOpen = () => {
        setState(!state)
    }

    const handleSuccess = () => {
        setOpen(!open)
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };

    const handleSubmitButtonClick =  () => {
        submitForm()
    }


    return (
        <>  
            <Tooltip title="Обратная связь">
                <IconButton onClick={handleOpen} className={classes.MessageButton}>
                    <CommentIcon color='inherit' label='Просмотр актов' />
                </IconButton>
            </Tooltip>
            <Dialog 
                open={state} 
                onClose={handleCloseDialog}
                maxWidth={'md'}
            >
                    <DialogTitle>
                        Напишите нам онлайн!
                        <IconButton onClick={handleCloseDialog} className={classes.button}>
                            <ClearTwoToneIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            variant="outlined"
                            fullWidth
                            multiline
                            name={'message'} 
                            {...getFieldProps('message')}
                        />
                    </DialogContent>
                        <DialogActions>
                        {getFieldProps('message').value !== '' ? <IconButton onClick={handleSubmitButtonClick}>
                            <SendTwoToneIcon />
                        </IconButton> : <></>}
                    </DialogActions>       
            </Dialog>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Сообщений успешно отправлено
                </Alert>
            </Snackbar>
        </>

    )
}